import { EntityTypes } from 'models/entity';

// The kinds of a proposed context relation, as the server names them. A requirement and a control both land in the
// task's controlIds.
export type CopilotContextProposalKind = 'requirement' | 'control' | 'process' | 'objective' | 'asset' | 'risk';

export const copilotContextProposalKinds: Record<CopilotContextProposalKind, EntityTypes> = {
  requirement: EntityTypes.Requirement,
  control: EntityTypes.Control,
  process: EntityTypes.Process,
  objective: EntityTypes.Objective,
  asset: EntityTypes.Asset,
  risk: EntityTypes.Risk,
};

// One relation the task assistant proposes for the open task, with the reason it names.
export class CopilotContextProposalItem {
  entityType: EntityTypes;

  entityId: number;

  kind: CopilotContextProposalKind;

  code?: string;

  name: string;

  reason: string;

  constructor() {
    this.entityType = EntityTypes.NotSet;
    this.entityId = 0;
    this.kind = 'control';
    this.name = '';
    this.reason = '';
  }
}

// A candidate the server refused to propose (already linked, not readable, not monitorable, a processing activity).
export class CopilotContextProposalRefusal {
  name: string;

  // the kind as the server names it; a refusal may carry a kind no item has (processingactivity)
  kind: string;

  // the entity type of the kind; undefined for a kind the client does not know, which the card shows as sent
  entityType?: EntityTypes;

  reason: string;

  constructor() {
    this.name = '';
    this.kind = '';
    this.reason = '';
  }
}

// The kinds only a refusal carries: the server leaves processing activities to the Context tab.
export const copilotContextRefusalKinds: Record<string, EntityTypes> = {
  processingactivity: EntityTypes.ProcessingActivity,
};

// The payload of a ContextProposal content block: what the task assistant added to the open task and what it left out.
export class CopilotContextProposal {
  items: CopilotContextProposalItem[];

  refused: CopilotContextProposalRefusal[];

  constructor() {
    this.items = [];
    this.refused = [];
  }
}
